<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records doctor-list">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="bg-white border-radius-5">
                            <div class="card-header d-flex justify-content-between bg-white border-0 align-items-center py-3">
                                <h1>Make An Appointment</h1>
                                <div class="mobScroll">
                                    <ul class="d-flex justify-content-center align-items-center mb-0 category">
                                        <li>
                                            <a href="#"><i class="icon icon-up-down-arrow"></i> Sort By: Availability</a>
                                        </li>
                                        <form class="radio-box d-flex justify-content-center align-items-center">
                                            <div class="form-group m-0">
                                                <input type="checkbox" id="html" />
                                                <label class="mb-0" for="html">In-Person Consults</label>
                                            </div>
                                            <div class="form-group m-0">
                                                <input type="checkbox" id="css" />
                                                <label class="mb-0" for="css">Online Consults</label>
                                            </div>
                                        </form>
                                        <li>
                                            <a href="#"><i class="icon icon-filter"></i> Filter</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="card-body pt-0 mobScroll">
                                <div class="d-flex justify-content-between align-items-center border-1 bg-white border-radius-5 p-3 mb-3 w-1200">
                                    <div class="dr-history d-flex">
                                        <figure class="mb-0">
                                            <router-link to="/doctor-profile"><img src="../../../../static/website/images/dr-image.svg" alt="" /></router-link>
                                        </figure>
                                        <div class="dr-history">
                                            <h3>Dr. Shabnam Das Kar</h3>
                                            <p class="mt-1">MD, FMNM | 10 Years Exp</p>
                                            <div class="Available mt-1"><p>Available in 6 mins</p></div>
                                        </div>
                                    </div>
                                    <div class="Prescribed">
                                        <ul class="d-flex">
                                            <li class="online">
                                                <a href="#"> <i class="icon icon-video"></i>Online</a>
                                            </li>
                                            <li>
                                                <a href="#"><i class="icon icon-graduation-cap"></i> MBBS, MD (Skin, VD and Leprosy)</a>
                                            </li>
                                        </ul>
                                        <p class="questionnaire"><i class="icon icon-map-macker"></i> TORONTO 18 York St ON, Canada M5J 2T8</p>
                                    </div>
                                    <div class="intake">
                                        <p><img src="../../../../static/website/images/registration.svg" alt="" class="icon" />Registration No: 13999/2000</p>
                                        <p><i class="icon icon-translate"></i>English, Hindi</p>
                                    </div>
                                    <div class="Reschedule"><router-link to="/calendy-calendar" class="btn btn-link btn-blue Book-an-Appointment mt-2">Book an Appointment</router-link></div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center border-1 bg-white border-radius-5 p-3 mb-3 w-1200">
                                    <div class="dr-history d-flex">
                                        <figure class="mb-0">
                                            <router-link to="/doctor-profile"><img src="../../../../static/website/images/dr-image.svg" alt="" /></router-link>
                                        </figure>
                                        <div class="dr-history">
                                            <h3>Dr. Shabnam Das Kar</h3>
                                            <p class="mt-1">MD, FMNM | 10 Years Exp</p>
                                            <div class="Available mt-1"><p>Available in 6 mins</p></div>
                                        </div>
                                    </div>
                                    <div class="Prescribed">
                                        <ul class="d-flex">
                                            <li class="online">
                                                <a href="#"> <i class="icon icon-video"></i>Online</a>
                                            </li>
                                            <li>
                                                <a href="#"><i class="icon icon-graduation-cap"></i> MBBS, MD (Skin, VD and Leprosy)</a>
                                            </li>
                                        </ul>
                                        <p class="questionnaire"><i class="icon icon-map-macker"></i> TORONTO 18 York St ON, Canada M5J 2T8</p>
                                    </div>
                                    <div class="intake">
                                        <p><img src="../../../../static/website/images/registration.svg" alt="" class="icon" />Registration No: 13999/2000</p>
                                        <p><i class="icon icon-translate"></i>English, Hindi</p>
                                    </div>
                                    <div class="Reschedule"><router-link to="/calendy-calendar" class="btn btn-link btn-blue Book-an-Appointment mt-2">Book an Appointment</router-link></div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center border-1 bg-white border-radius-5 p-3 mb-3 w-1200">
                                    <div class="dr-history d-flex">
                                        <figure class="mb-0">
                                            <router-link to="/doctor-profile"><img src="../../../../static/website/images/dr-image.svg" alt="" /></router-link>
                                        </figure>
                                        <div class="dr-history">
                                            <h3>Dr. Shabnam Das Kar</h3>
                                            <p class="mt-1">MD, FMNM | 10 Years Exp</p>
                                            <div class="Available mt-1"><p>Available in 6 mins</p></div>
                                        </div>
                                    </div>
                                    <div class="Prescribed">
                                        <ul class="d-flex">
                                            <li class="online">
                                                <a href="#"> <i class="icon icon-video"></i>Online</a>
                                            </li>
                                            <li>
                                                <a href="#"><i class="icon icon-graduation-cap"></i> MBBS, MD (Skin, VD and Leprosy)</a>
                                            </li>
                                        </ul>
                                        <p class="questionnaire"><i class="icon icon-map-macker"></i> TORONTO 18 York St ON, Canada M5J 2T8</p>
                                    </div>
                                    <div class="intake">
                                        <p><img src="../../../../static/website/images/registration.svg" alt="" class="icon" />Registration No: 13999/2000</p>
                                        <p><i class="icon icon-translate"></i>English, Hindi</p>
                                    </div>
                                    <div class="Reschedule"><a href="#" class="btn btn-link btn-gray Book-an-Appointment mt-2">Book an Appointment</a></div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center border-1 bg-white border-radius-5 p-3 mb-3 w-1200">
                                    <div class="dr-history d-flex">
                                        <figure class="mb-0">
                                            <router-link to="/doctor-profile"><img src="../../../../static/website/images/dr-image.svg" alt="" /></router-link>
                                        </figure>
                                        <div class="dr-history">
                                            <h3>Dr. Shabnam Das Kar</h3>
                                            <p class="mt-1">MD, FMNM | 10 Years Exp</p>
                                            <div class="Available mt-1"><p>Available in 6 mins</p></div>
                                        </div>
                                    </div>
                                    <div class="Prescribed">
                                        <ul class="d-flex">
                                            <li class="online">
                                                <a href="#"> <i class="icon icon-video"></i>Online</a>
                                            </li>
                                            <li>
                                                <a href="#"><i class="icon icon-graduation-cap"></i> MBBS, MD (Skin, VD and Leprosy)</a>
                                            </li>
                                        </ul>
                                        <p class="questionnaire"><i class="icon icon-map-macker"></i> TORONTO 18 York St ON, Canada M5J 2T8</p>
                                    </div>
                                    <div class="intake">
                                        <p><img src="../../../../static/website/images/registration.svg" alt="" class="icon" />Registration No: 13999/2000</p>
                                        <p><i class="icon icon-translate"></i>English, Hindi</p>
                                    </div>
                                    <div class="Reschedule"><a href="#" class="btn btn-link btn-gray Book-an-Appointment mt-2">Book an Appointment</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "doctor-list",
        data() {
            return {};
        },
        created(){
           this.pageName('Consultation History')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/doctor/doctor-list.vue